import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-video', 'play', 'Žiūrėti video');
